import { render, staticRenderFns } from "./unbind.vue?vue&type=template&id=38e9d216&scoped=true"
import script from "./unbind.vue?vue&type=script&lang=js"
export * from "./unbind.vue?vue&type=script&lang=js"
import style0 from "./unbind.vue?vue&type=style&index=0&id=38e9d216&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e9d216",
  null
  
)

export default component.exports